module.exports = __webpack_public_path__ + "1aba9045bf05a3c77d309f5fdb153524.MP3";